{
  "title": "Indikativ återbetalningsplan",
  "disclaimer": "Denna återbetalningsplan är indikativ, endast avsedd som information och kan vara felaktig. Faktiska kostnader och betalningar kan variera beroende på de slutliga villkoren från långivaren.",
  "exportToExcel": "Exportera till Excel",
  "exporting": "Exporterar…",
  "tabs": {
    "table": "Tabell",
    "graph": "Diagram"
  },
  "month": "Månad",
  "payment": "Betalning",
  "interest": "Ränta",
  "principal": "Amortering",
  "fees": "Avgifter",
  "remainingBalance": "Kvarvarande lånebelopp",
  "total": "Totalt",
  "setupFee": "Uppläggningsavgift (engångsavgift)",
  "totalRepaid": "Totalt att återbetala",
  "totalCostOfCredit": "Total kreditkostnad",
  "loading": "Laddar…",
  "totalsTitle": "Totalt",
  "slider": {
    "label": "Återbetala över",
    "originalTerm": "Ursprunglig löptid"
  },
  "savings": {
    "title": "Möjlig besparing vid tidig återbetalning",
    "interestSaved": "Sparad ränta",
    "feesSaved": "Sparade avgifter",
    "grossSaved": "Total besparing (brutto)",
    "earlyRepaymentFee": "Avgift för förtidsinlösen",
    "repaidEarlier": "Återbetald {{duration}} tidigare – indikativ uppskattning som utgår från att hela kvarvarande lånebeloppet regleras vid månadens slut."
  },
  "tooltips": {
    "setupFee": "En engångsavgift som tas ut när lånet läggs upp. Visas på månad 0.",
    "totalCostOfCredit": "Allt som lånet kostar utöver det lånade beloppet (inklusive all ränta plus alla avgifter).",
    "totalRepaid": "Det totala beloppet du betalar tillbaka under löptiden: det lånade beloppet plus den totala kreditkostnaden.",
    "interestSaved": "Ränta som undviks genom att återbetala lånet i förtid i stället för att behålla lånet hela löptiden.",
    "feesSaved": "Återkommande avgifter, till exempel avi- och autogiroavgifter, som undviks för de månader som hoppas över.",
    "grossSaved": "Sparad ränta och sparade avgifter sammantaget, innan eventuell avgift för förtidsåterbetalning dras av.",
    "earlyRepaymentFee": "En avgift som långivaren kan ta ut för att lösa lånet före löptidens slut."
  }
}
